import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/yangyang/Repos/boom/apps/web/app/product/[slug]/components/OffersDisplay.tsx");
